import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl, isImageSrc } from '../utils';

function ProductCard({ product }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${product.id}`);
  };

  const images = product?.images?.length > 0
    ? product.images
    : [product?.image || '🌸'];

  return (
    <div className="product-card" onClick={handleClick}>
      <div className="product-image">
        {isImageSrc(images[0]) ? (
          <img
            src={getImageUrl(images[0])}
            alt={product.name}
            className="product-photo"
          />
        ) : (
          <span className="product-emoji">{images[0]}</span>
        )}
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.description}</p>
        {product.flowerCount > 0 && (
          <p className="product-flowers">{product.flowerCount} цветов</p>
        )}
        <div className="product-footer">
          <span className="product-price">{product.price.toLocaleString()} ₽</span>
          <button className="buy-button" onClick={(e) => {
            e.stopPropagation();
            navigate(`/product/${product.id}`);
          }}>
            Подробнее
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
